module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "v-fade"
    }
  }, [(_vm.active) ? _c('div', {
    staticClass: "Modal",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "Modal-content"
  }, [(_vm.dismissable === true) ? _c('button', {
    staticClass: "Modal-close",
    on: {
      "click": _vm.close
    }
  }, [_c('icon', {
    attrs: {
      "icon": "close"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "u-screenreader"
  }, [_vm._v("close")])], 1) : _vm._e(), _vm._v(" "), (!!_vm.title) ? _c('p', {
    staticClass: "Modal-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52cdab50","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/modal.vue
// module id = 335
// module chunks = 0